/**
 * The thing the visitor was trying to do when a gate stopped them.
 *
 * A gate interrupts an intent — follow this habitat, like this clip, join this talk — and the whole
 * point of the flow is that the intent survives. Without this, someone who signs up to follow a
 * habitat ends up signed in, back on the page, and *not* following it: they have to work out that
 * their click was swallowed and do it again.
 *
 * A module-level slot rather than redux because it holds a function, which redux may not: actions
 * and state have to stay serializable or time-travel, persistence and the devtools all break. One
 * slot is enough — `openSpeedyFlow` refuses to start a second flow while one is running, so there
 * is never more than one intent outstanding.
 */
let pending: (() => void) | undefined;

export const setPendingAction = (action?: () => void) => {
  pending = action;
};

/** Returns the pending action and clears it, so it can never run twice. */
export const takePendingAction = () => {
  const action = pending;
  pending = undefined;
  return action;
};

export const clearPendingAction = () => {
  pending = undefined;
};
